// @flow

import type { Action } from './state';

export type State = {|
  mcid: string | null,
  uid: string | null,
  analytics: {
    url: string,
  },
  sessionId: string | null,
  searchSessionId: string | null,
  serverName: string | null,
  hostName: string | null,
  vcsRevision: number | null,
  vcsBranch: string | null,
  drsInfo: string | null,
  uvmScore: string | null,
  retargetingUrl: string | null,
  uniqueId: string | null,
  domainName: string | null,
|};

const emptyState = () => ({
  mcid: null,
  uid: null,
  analytics: {
    url: '',
  },
  sessionId: null,
  searchSessionId: null,
  serverName: null,
  hostName: null,
  vcsRevision: null,
  vcsBranch: null,
  drsInfo: null,
  uvmScore: null,
  retargetingUrl: null,
  uniqueId: null,
  domainName: null,
});

// eslint-disable-next-line no-unused-vars
export default (state: State = emptyState(), action: Action) => state;
